import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Source } from "trader.ts/types/source";
import {
  b2fileid,
  student_attachment_id,
  studentid,
} from "../../../sql/classy/types";
import * as FA from "../../../styles/fontawesome.css.classes";
import * as style from "../../../styles/style.css.classes";
import { fileboxWithAutosave } from "../../client/fileinput";
import { renderDeleteButton } from "../../client/savebutton";
import { arrayBufferToBase64Client } from "../../lib/arraybuffertobase64";
import * as routes from "../../routes";

export function render(opts: {
  student: { id: studentid };
  attachments: {
    id: student_attachment_id;
    label: string;
    storagefileid: b2fileid;
    mimetype: string;
  }[];
}): HTMLElement | HTMLElement[] {
  const attachmentS: Source<null | {
    data: ArrayBuffer;
    mimetype: string;
    name: string;
  }> = new Source(null);

  return (
    <div>
      <article style="display: flex;">
        <div className={style.text_with_icon}>
          <i className={FA.icon_paperclip_solid}></i>
          <div>{"Bestanden"}</div>
        </div>
        {fileboxWithAutosave({
          initiallabel: <i className={FA.icon_plus_solid}></i>,
          selectedlabel: "",
          className: style.button_has_only_icon,
          style: " margin-left: 16px; height: 28px; padding: 5px 16px;",
          onSave: () => location.reload(),
          doSave: async (attachment) => {
            await rpc(routes.saveStudentAttachmentSpec, undefined, {
              studentid: opts.student.id,
              attachment: {
                name: attachment.name,
                mimetype: attachment.mimetype,
                data_b64: arrayBufferToBase64Client(attachment.data),
              },
            });
          },
        })}
      </article>
      {opts.attachments.map((attachment) => {
        return (
          <article className={style.text_with_icon}>
            <i className={FA.icon_paperclip_solid}></i>
            <a
              href={routes.downloadStudentAttachmentSpec.route.link({
                student_attachment_id: attachment.id,
              })}
              target="_blank"
            >
              {attachment.label}
            </a>
            {renderDeleteButton({
              label: <i className={FA.icon_trash_alt_solid}></i>,
              className: style.button_has_only_icon + style.button_white,
              style: " margin-left: 16px; height: 28px; padding: 5px 16px;",
              dontShowLabelAgainInConfirmation: true,
              confirmationLabel: "Ben je zeker dat je dit bestand wilt verwijderen?",
              doDelete: async function () {
                await rpc(
                  routes.deleteStudentAttachmentSpec,
                  { student_attachment_id: attachment.id },
                  {},
                );
                location.reload();
              },
              redirectTo: "",
            })}
          </article>
        );
      })}

      {
        // renderFileInput({
        //   source: attachmentS,
        //   accept: "*",
        //   initiallabel: <i className={FA.icon_plus_solid}></i>,
        //   selectedlabel: "Bestand",
        //   style: "",
        // })
      }
      {
        // dyn(attachmentS, function (attachment) {
        //   if (attachment === null) {
        //     return <span></span>;
        //   } else {
        //     return (
        //       <div>
        //         {renderSaveButton({
        //           save: async () => {
        //             await rpc(routes.saveStudentAttachmentSpec, undefined, {
        //               studentid: opts.student.id,
        //               attachment: {
        //                 name: attachment.name,
        //                 mimetype: attachment.mimetype,
        //                 data_b64: arrayBufferToBase64(attachment.data),
        //               },
        //             });
        //             return { tag: "success" };
        //           },
        //           reload: true,
        //         })}
        //       </div>
        //     );
        //   }
        // })
      }
    </div>
  );
}
